<form [formGroup]="productListForm">
  <div class="row">
    <div class="col-lg-6 mb-3">
      <input-field
        [requiredLabel]="true"
        [label]="'Full Name'"
        [type]="'text'"
        [placeholder]="'Enter Full name'"
        [errormessage]="'Full Name is required'"
        formControlName="name"
      >
      </input-field>
    </div>
    <div class="col-lg-6 mb-3">
      <input-field
        [requiredLabel]="true"
        [label]="'Short Code'"
        [type]="'text'"
        [placeholder]="'Enter Short Code'"
        [errormessage]="'Short Code is required'"
        formControlName="code"
      >
      </input-field>
    </div>
    <!-- <div class="col-lg-6 mb-3">
      <input-field
      [label]="'Product Code Mask'"
      [type]="'text'"
      [placeholder]="'Enter Product Code Mask'"
      formControlName="productCodeMask">
    </input-field>
    </div> -->
  </div>
</form>
